<script>
import axios from 'axios';
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import Layout from "@/layouts/main-copy.vue";
import RicercaFiltro from "@/components/filtro-modal";
import IconLegend from '@/components/IconLegend.vue';
import addressMixin from '@/mixins/textFormatMixin';
import defaultImage from '@/assets/images/ImmoprogrammScrittaCompatta_Q.png';
import { Autoplay, Thumbs, Pagination, Navigation, EffectCoverflow, Mousewheel, Scrollbar, EffectFade, EffectFlip, EffectCreative } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/autoplay";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/mousewheel';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-coverflow';

import Typed from 'typed.js';
import { mapGetters } from 'vuex';

export default {
    mixins: [addressMixin],
    data() {
        return {
            defaultImage,
            searchQuery: '',
            selectedCities: [],
            cityOptions: [],
            immobileTipologia: '',
            immobileCategoria: '',
            minPrice: null,
            maxPrice: null,
            filterNoPrice: false,
            minLocali: null,
            maxLocali: null,
            minAnnoCostruzione: null,
            maxAnnoCostruzione: null,
            minSuperficie: null,
            maxSuperficie: null,
            rentSale: '',

            // Newsletter form data
            newsletterSelectedCities: [],
            newsletterImmobileTipologia: '',
            newsletterImmobileCategoria: '',
            newsletterMinPrice: null,
            newsletterMaxPrice: null,
            newsletterFilterNoPrice: false,
            newsletterMinLocali: null,
            newsletterMaxLocali: null,
            newsletterMinAnnoCostruzione: null,
            newsletterMaxAnnoCostruzione: null,
            newsletterMinSuperficie: null,
            newsletterMaxSuperficie: null,
            newsletterRentSale: '',

            qrCodes: [],
            filteredQrCodes: [],

            Autoplay: Autoplay, Thumbs: Thumbs, Pagination: Pagination, Navigation: Navigation, EffectCreative: EffectCreative,
            coverflowModules: [EffectCoverflow, Pagination],
            mousewheelModules: [Mousewheel, Pagination],
            scrollbarModules: [Scrollbar, Navigation, Pagination],
            effectFadeModules: [EffectFade, Autoplay],
            effectFlipModules: [EffectFlip, Pagination],

            pagination: {
                clickable: true,
                el: '.swiper-pagination',
                renderBullet: function (index, className) {
                    return '<span class=' + className + '>' + (index + 1) + '</span>';
                },
            },
        };
    },

    components: {
        Layout,
        PageHeader,
        Footer,
        RicercaFiltro,
        Swiper,
        SwiperSlide,
        IconLegend
    },
    
    async mounted() {
        await this.fetchQRCodes();
        this.initializeTyped();
    },

    computed: {
        ...mapGetters(['currentImages']),
        vetrinaAffitto() {
            const showcasedQRs = this.qrCodes.filter(qrCode => qrCode.showcase && qrCode.rent_sale === 'Affitto');
            return showcasedQRs;
        },
        vetrinaVendita() {
            const showcasedQRs = this.qrCodes.filter(qrCode => qrCode.showcase && qrCode.rent_sale === 'Vendita');
            return showcasedQRs;
        },
        vetrinaGestione() {
            const showcasedQRs = this.qrCodes.filter(qrCode => qrCode.in_gestione);
            return showcasedQRs;
        },
    },

    methods: {
        showNewsletterModal() {
            this.$refs.newsletterModal.schermataFiltroModal = true;
        },
        initializeTyped() {
            const options = {
                strings: ['Un tetto per la vita!'],
                typeSpeed: 50,
                backSpeed: 30,
                backDelay: 3500,
                loop: true,
                showCursor: false
            };
            new Typed('#typed-output', options);
        },
        goToQrCodeDetails(doc) {
            this.$router.push({ name: 'dettagli', query: { oggetto: doc.oggetto } });
        },

        handleUpdateSelectedCities(newCities) {
            this.selectedCities = Array.isArray(newCities) ? newCities : [newCities];
        },

        filterImmobili() {          
            this.$router.push({
                name: 'immobili',
                query: {
                    searchQuery: this.searchQuery,
                    selectedCities: this.selectedCities,
                    cityOptions: this.cityOptions,
                    immobileTipologia: this.immobileTipologia,
                    immobileCategoria: this.immobileCategoria,
                    minPrice: this.minPrice,
                    maxPrice: this.maxPrice,
                    filterNoPrice: this.filterNoPrice,
                    minLocali: this.minLocali,
                    maxLocali: this.maxLocali,
                    minAnnoCostruzione: this.minAnnoCostruzione,
                    maxAnnoCostruzione: this.maxAnnoCostruzione,
                    minSuperficie: this.minSuperficie,
                    maxSuperficie: this.maxSuperficie,
                    rentSale: this.rentSale,
                }
            });
        },

        goToAffittoList() {
            this.rentSale = 'Affitto';  // Set rentSale to "Affitto"
            this.$router.push({
                name: 'immobili',
                query: {
                    rentSale: this.rentSale,
                }
            });
        },

        goToVenditaList() {
            this.rentSale = 'Vendita';
            this.$router.push({
                name: 'immobili',
                query: {
                    rentSale: this.rentSale,
                }
            });
        },
        async fetchQRCodes() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/immobile-list/`);
                this.qrCodes = response.data;
                console.log("this.qrCodes:", this.qrCodes);
                this.filteredQrCodes = this.qrCodes;              
                const cities = new Set(this.qrCodes.map(immobile => immobile.city));
                this.cityOptions = Array.from(cities);
                console.log("Unique Cities:", this.cityOptions);
            } catch (error) {
                console.error('Error fetching immobili and their details:', error);
            }
        },

        getWidgets(qrCode) {
            const widgets = this.setProductDetailsWidgets(qrCode);
            return this.getFilteredProductDetailsWidgets(widgets);
        }
    }
};
</script>

<template>
    <Layout>
      <PageHeader :titoloScheda="$t('homepage')" />
      <div class="hero-section">
        <swiper 
          :autoplay="{ delay: 5000, disableOnInteraction: false }"
          class="hero-slider" 
          :loop="true" 
          :effect="'fade'" 
          :modules="effectFadeModules">
          <swiper-slide v-for="image in currentImages" :key="image.id">
            <img :src="image.url" alt="Background" class="img-fluid">
          </swiper-slide>
        </swiper>
        <div class="centered-content">
          <div id="typed-output" class="typed-text"></div>
          <div class="ricerca-filtro-wrapper">
            <RicercaFiltro 
              :searchQuery="searchQuery"
              :selectedCities="selectedCities"
              :cityOptions="cityOptions"
              :immobileTipologia="immobileTipologia"
              :immobileCategoria="immobileCategoria"
              :minPrice="minPrice"
              :maxPrice="maxPrice"
              :filterNoPrice="filterNoPrice"
              :minLocali="minLocali"
              :maxLocali="maxLocali"
              :minAnnoCostruzione="minAnnoCostruzione"
              :maxAnnoCostruzione="maxAnnoCostruzione"
              :minSuperficie="minSuperficie"
              :maxSuperficie="maxSuperficie"
              :rentSale="rentSale"
              :qrCodes="qrCodes"
              @update:searchQuery="val => searchQuery = val"
              @update:selectedCities="handleUpdateSelectedCities"
              @update:immobileTipologia="val => immobileTipologia = val"
              @update:immobileCategoria="val => immobileCategoria = val"
              @update:minPrice="val => minPrice = val"
              @update:maxPrice="val => maxPrice = val"
              @update:filterNoPrice="val => filterNoPrice = val"
              @update:minLocali="val => minLocali = val"
              @update:maxLocali="val => maxLocali = val"
              @update:minAnnoCostruzione="val => minAnnoCostruzione = val"
              @update:maxAnnoCostruzione="val => maxAnnoCostruzione = val"
              @update:minSuperficie="val => minSuperficie = val"
              @update:maxSuperficie="val => maxSuperficie = val"
              @update:rentSale="val => rentSale = val"
              @onFilter="filterImmobili"
            />
          </div>
        </div>
      </div>
      <BCol cols="12">
        <BRow class="h-100">
          <BCol xxl="3" class="d-flex card-spacing">
            <BCard no-body class="card-info d-flex flex-column h-100 w-100">
              <BCardBody class="flex-grow-1 d-flex flex-column">
                <div class="d-flex flex-grow-1">
                  <div class="flex-grow-1 ms-3">
                    <h4 class="mb-1 fw-medium" style="color: white;">{{$t('immobili-in-affitto')}}</h4>
                    <p class="card-text">Trova il posto perfetto tra le nostre offerte di affitto!</p>
                  </div>
                </div>
              </BCardBody>
              <BCardFooter @click="goToAffittoList" style="cursor: pointer;">
                <div class="text-center">
                  {{$t('vedi-immobili-affitto')}} <i class="ri-arrow-right-s-line align-middle lh-1"></i>
                </div>
              </BCardFooter>
            </BCard>
          </BCol>
          <BCol xxl="3" class="d-flex card-spacing">
            <BCard no-body class="card-info d-flex flex-column h-100 w-100">
              <BCardBody class="flex-grow-1 d-flex flex-column">
                <div class="d-flex flex-grow-1">
                  <div class="flex-grow-1 ms-3">
                    <h4 class="mb-1 fw-medium" style="color: white;">{{$t('immobili-in-vendita')}}</h4>
                    <p class="card-text">Guarda subito i nostri immobili in vendita!</p>
                  </div>
                </div>
              </BCardBody>
              <BCardFooter @click="goToVenditaList" style="cursor: pointer;">
                <div class="text-center">
                  {{$t('vedi-immobili-vendita')}} <i class="ri-arrow-right-s-line align-middle lh-1"></i>
                </div>
              </BCardFooter>
            </BCard>
          </BCol>
          <BCol xxl="3" class="d-flex card-spacing">
            <BCard no-body class="card-info d-flex flex-column h-100 w-100">
              <BCardBody class="flex-grow-1 d-flex flex-column">
                <div class="d-flex flex-grow-1">
                  <div class="flex-grow-1 ms-3">
                    <h4 class="mb-1 fw-medium" style="color: white;">{{$t('newsletter')}} <i class="ri-notification-2-line"></i></h4>
                    <p class="card-text">Ricevi tramite email quando pubblichiamo quello che stai cercando!</p>
                  </div>
                </div>
              </BCardBody>
              <BCardFooter @click="showNewsletterModal" style="cursor: pointer;">
                <div class="text-center">
                  Iscriviti <i class="ri-arrow-right-s-line align-middle lh-1"></i>
                </div>
              </BCardFooter>
              <RicercaFiltro
                ref="newsletterModal"
                :isNewsletterMode="true"
                :selectedCities="newsletterSelectedCities"
                :cityOptions="cityOptions"
                :immobileTipologia="newsletterImmobileTipologia"
                :immobileCategoria="newsletterImmobileCategoria"
                :minPrice="newsletterMinPrice"
                :maxPrice="newsletterMaxPrice"
                :filterNoPrice="newsletterFilterNoPrice"
                :minLocali="newsletterMinLocali"
                :maxLocali="newsletterMaxLocali"
                :minAnnoCostruzione="newsletterMinAnnoCostruzione"
                :maxAnnoCostruzione="newsletterMaxAnnoCostruzione"
                :minSuperficie="newsletterMinSuperficie"
                :maxSuperficie="newsletterMaxSuperficie"
                :rentSale="newsletterRentSale"
                :qrCodes="qrCodes"
                @update:selectedCities="val => newsletterSelectedCities = val"
                @update:immobileTipologia="val => newsletterImmobileTipologia = val"
                @update:immobileCategoria="val => newsletterImmobileCategoria = val"
                @update:minPrice="val => newsletterMinPrice = val"
                @update:maxPrice="val => newsletterMaxPrice = val"
                @update:filterNoPrice="val => newsletterFilterNoPrice = val"
                @update:minLocali="val => newsletterMinLocali = val"
                @update:maxLocali="val => newsletterMaxLocali = val"
                @update:minAnnoCostruzione="val => newsletterMinAnnoCostruzione = val"
                @update:maxAnnoCostruzione="val => newsletterMaxAnnoCostruzione = val"
                @update:minSuperficie="val => newsletterMinSuperficie = val"
                @update:maxSuperficie="val => newsletterMaxSuperficie = val"
                @update:rentSale="val => newsletterRentSale = val"
              />
            </BCard>
          </BCol>
          <BCol xxl="3" class="d-flex card-spacing">
            <BCard no-body class="card-info d-flex flex-column h-100 w-100">
              <BCardBody class="flex-grow-1 d-flex flex-column">
                <div class="d-flex flex-grow-1">
                  <div class="flex-grow-1 ms-3">
                    <h4 class="mb-1 fw-medium" style="color: white;">{{$t('rivista')}}</h4>
                    <p class="card-text">Sfoglia la nostra rivista!</p>
                  </div>
                </div>
              </BCardBody>
            </BCard>
          </BCol>
        </BRow>
        <BRow class="mt-4">
          <BCard no-body>
            <BCardHeader class="d-flex justify-content-between align-items-center">
              <BCardTitle class="mb-0 card-title-underline" style="font-size: 24px;">VETRINA IMMOBILI IN AFFITTO</BCardTitle>
              <IconLegend :iconList="defaultProductDetailsWidgets" />
            </BCardHeader>
            <BCardBody>
              <swiper class="swiper responsive-swiper rounded gallery-light pb-4"
                :autoplay="{ delay: 2500, disableOnInteraction: false }"
                :slidesPerView="1" 
                :spaceBetween="10" 
                :pagination="{ el: '.swiper-pagination-affitto', clickable: true, dynamicBullets: true }"
                :navigation="{ nextEl: '.swiper-button-next-affitto', prevEl: '.swiper-button-prev-affitto' }"
                :modules="[Autoplay, Pagination, Navigation]"
                :breakpoints="{ 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 3, spaceBetween: 40 }, 1200: { slidesPerView: 4, spaceBetween: 50 } }">
                <swiper-slide v-for="qrCode in vetrinaAffitto" :key="qrCode.id">
                  <BCard no-body class="gallery-box" :class="{ 'ribbon-box ribbon-fill shadow-none mb-lg-0': qrCode.affittato_venduto }" @click="goToQrCodeDetails(qrCode)">
                    <div v-if="qrCode.affittato_venduto" class="ribbon ribbon-red">{{ qrCode.rent_sale === 'Affitto' ? 'Affittato' : 'Venduto' }}</div>
                    <div class="gallery-container">
                      <img :src="qrCode.images && qrCode.images.length > 0 ? qrCode.images[0].url : defaultImage" alt="Immobile Image" class="gallery-img img-fluid mx-auto" />
                      <div class="gallery-overlay">
                        <h5 class="overlay-caption">{{ this.generateTitle(qrCode) || $t('caricamento') }}</h5>
                      </div>
                    </div>
                    <div class="box-content">
                      <div class="d-flex align-items-center mt-1 flex-wrap">
                        <div v-for="(item, index) in getWidgets(qrCode)" :key="index" class="widget-item p-1 m-1 border border-dashed rounded">
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm me-1 rounded bg-transparent d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                              <img :src="item.icon" alt="Icon" class="img-fluid" style="width: 19px; height: 19px;">
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0" style="font-size: 14px;">{{ item.labelDetail }}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-1 p-2 flex-wrap">{{ this.formatListingSummary(qrCode) || $t('caricamento') }}</div>
                      <div v-if="qrCode && this.formatFullAddress(qrCode)" class="d-flex align-items-center mt-1 p-2 flex-wrap">
                        <i class="ri-map-pin-fill"></i> {{ this.formatFullAddress(qrCode) }}
                      </div>
                    </div>
                  </BCard> 
                </swiper-slide>
                <swiper-slide>
                  <BCard no-body class="gallery-box" style="height: 200px; width: 100%; cursor: pointer;" @click="goToAffittoList">
                    <BCard no-body class="d-flex align-items-center justify-content-center bg-info text-white" style="height: 100%; width: 100%;">
                      <h2 class="overlay-caption mb-0 text-center" style="color: white; transition: color 0.3s;">{{$t('vedi-immobili-affitto')}}</h2>
                    </BCard>
                  </BCard>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-dark swiper-pagination-affitto"></div>
              </swiper>
              <div class="swiper-button-next swiper-button-next-affitto"></div>
              <div class="swiper-button-prev swiper-button-prev-affitto"></div>
            </BCardBody>
          </BCard> 
          <BCard no-body>
            <BCardHeader class="d-flex justify-content-between align-items-center">
              <BCardTitle class="mb-0 card-title-underline" style="font-size: 24px;">VETRINA IMMOBILI IN VENDITA</BCardTitle>
              <IconLegend :iconList="defaultProductDetailsWidgets" />
            </BCardHeader>
            <BCardBody>
              <swiper class="swiper responsive-swiper rounded gallery-light pb-4" 
                :autoplay="{ delay: 2500, disableOnInteraction: false }" 
                :slidesPerView="1" 
                :spaceBetween="10" 
                :pagination="{ el: '.swiper-pagination-vendita', clickable: true, dynamicBullets: true }" 
                :navigation="{ nextEl: '.swiper-button-next-vendita', prevEl: '.swiper-button-prev-vendita' }" 
                :modules="[Autoplay, Pagination, Navigation]" 
                :breakpoints="{ 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 3, spaceBetween: 40 }, 1200: { slidesPerView: 4, spaceBetween: 50 }, }">
                <swiper-slide v-for="qrCode in vetrinaVendita" :key="qrCode.id">
                  <BCard no-body class="gallery-box" :class="{ 'ribbon-box ribbon-fill shadow-none mb-lg-0': qrCode.affittato_venduto }" @click="goToQrCodeDetails(qrCode)">
                    <div v-if="qrCode.affittato_venduto" class="ribbon ribbon-red">{{ qrCode.rent_sale === 'Affitto' ? 'Affittato' : 'Venduto' }}</div>
                    <div class="gallery-container">
                      <img :src="qrCode.images && qrCode.images.length > 0 ? qrCode.images[0].url : defaultImage" alt="Immobile Image" class="gallery-img img-fluid mx-auto" />
                      <div class="gallery-overlay">
                        <h5 class="overlay-caption">{{ this.generateTitle(qrCode) || $t('caricamento') }}</h5>
                      </div>
                    </div>
                    <div class="box-content">
                      <div class="d-flex align-items-center mt-1 flex-wrap">
                        <div v-for="(item, index) in getWidgets(qrCode)" :key="index" class="widget-item p-1 m-1 border border-dashed rounded">
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm me-1 rounded bg-transparent d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                              <img :src="item.icon" alt="Icon" class="img-fluid" style="width: 19px; height: 19px;">
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0" style="font-size: 14px;">{{ item.labelDetail }}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-1 p-2 flex-wrap">{{ this.formatListingSummary(qrCode) || $t('caricamento') }}</div>
                      <div v-if="qrCode && this.formatFullAddress(qrCode)" class="d-flex align-items-center mt-1 p-2 flex-wrap">
                        <i class="ri-map-pin-fill"></i> {{ this.formatFullAddress(qrCode) }}
                      </div>                   
                    </div>
                  </BCard> 
                </swiper-slide>
                <swiper-slide>
                  <BCard no-body class="gallery-box" style="height: 200px; width: 100%; cursor: pointer;" @click="goToVenditaList">
                    <BCard no-body class="d-flex align-items-center justify-content-center bg-info text-white" style="height: 100%; width: 100%;">
                      <h2 class="overlay-caption mb-0 text-center" style="color: white; transition: color 0.3s;">{{$t('vedi-immobili-vendita')}}</h2>
                    </BCard>
                  </BCard>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-dark swiper-pagination-vendita"></div>
              </swiper>
              <div class="swiper-button-next swiper-button-next-vendita"></div>
              <div class="swiper-button-prev swiper-button-prev-vendita"></div>
            </BCardBody>
          </BCard> 
          <BCard no-body>
            <BCardHeader class="d-flex justify-content-between align-items-center">
              <BCardTitle class="mb-0 card-title-underline" style="font-size: 24px;">ALCUNE NOSTRE GESTIONI</BCardTitle>
              <IconLegend :iconList="defaultProductDetailsWidgets" />
            </BCardHeader>
            <BCardBody>
              <swiper class="swiper responsive-swiper rounded gallery-light pb-4" 
                :autoplay="{ delay: 2500, disableOnInteraction: false }" 
                :slidesPerView="1" 
                :spaceBetween="10" 
                :pagination="{ el: '.swiper-pagination-gestione', clickable: true, dynamicBullets: true }" 
                :navigation="{ nextEl: '.swiper-button-next-gestione', prevEl: '.swiper-button-prev-gestione' }" 
                :modules="[Autoplay, Pagination, Navigation]" 
                :breakpoints="{ 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 3, spaceBetween: 40 }, 1200: { slidesPerView: 4, spaceBetween: 50 }, }">
                <swiper-slide v-for="qrCode in vetrinaGestione" :key="qrCode.id">
                  <BCard no-body class="gallery-box" :class="{ 'ribbon-box ribbon-fill shadow-none mb-lg-0': qrCode.affittato_venduto }" @click="goToQrCodeDetails(qrCode)">
                    <div v-if="qrCode.affittato_venduto" class="ribbon ribbon-red">{{ qrCode.rent_sale === 'Affitto' ? 'Affittato' : 'Venduto' }}</div>
                    <div class="gallery-container">
                      <img :src="qrCode.images && qrCode.images.length > 0 ? qrCode.images[0].url : defaultImage" alt="Immobile Image" class="gallery-img img-fluid mx-auto" />
                      <div class="gallery-overlay">
                        <h5 class="overlay-caption">{{ this.generateTitle(qrCode) || $t('caricamento') }}</h5>
                      </div>
                    </div>
                    <div class="box-content">
                      <div class="d-flex align-items-center mt-1 flex-wrap">
                        <div v-for="(item, index) in getWidgets(qrCode)" :key="index" class="widget-item p-1 m-1 border border-dashed rounded">
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm me-1 rounded bg-transparent d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                              <img :src="item.icon" alt="Icon" class="img-fluid" style="width: 19px; height: 19px;">
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0" style="font-size: 14px;">{{ item.labelDetail }}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-1 p-2 flex-wrap">{{ this.formatListingSummary(qrCode) || $t('caricamento') }}</div>
                      <div v-if="qrCode && this.formatFullAddress(qrCode)" class="d-flex align-items-center mt-1 p-2 flex-wrap">
                        <i class="ri-map-pin-fill"></i> {{ this.formatFullAddress(qrCode) }}
                      </div>                   
                    </div>
                  </BCard> 
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-dark swiper-pagination-gestione"></div>
              </swiper>
              <div class="swiper-button-next swiper-button-next-gestione"></div>
              <div class="swiper-button-prev swiper-button-prev-gestione"></div>
            </BCardBody>
          </BCard>
        </BRow>
      </BCol>              
    </Layout>
    <Footer />
</template>

<style scoped>
.ribbon-red {
    background-color: red !important;
    color: white !important;
    padding: 90px 130px 10px !important; /* Increase padding for a wider ribbon */
    font-size: 20px !important;
    font-weight: bold !important;
    position: absolute !important;
    top: -95px !important;
    left: -170px !important; 
    z-index: 10 !important;
    transform: rotate(-45deg) !important;
    transform-origin: top right !important;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5) !important;
}

.hero-section {
  position: relative;

  margin: 0 auto 30px auto; /* This centers the section horizontally */
}

.hero-slider img {
  width: 100%;
  height: 97vh; /* Ensure full viewport height */
  object-fit: cover; /* Cover the entire area without distortion */
}

.centered-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  z-index: 10; /* Higher z-index to ensure visibility above the slider */
  padding: 20px;
  box-sizing: border-box;
}

.image-container {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
}

.gallery-box {
  cursor: pointer; /* Make cursor a pointer to indicate clickable area */
}

.gallery-container {
  position: relative;
  height: 0;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  overflow: hidden;
    transition: all 0.3s ease;
}

.gallery-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Covers the area without distorting the aspect ratio, may crop the image */
}

.typed-text {
  color: white; /* Sets the text color to white */
  font-size: 2rem; /* Sets the font size to 2rem (adjust as needed) */
  font-weight: bold; /* Optional: makes the text bold */
}

#typed-output::after {
  content: '|'; /* Defines the caret character */
  color: white; /* Sets the caret color */
  font-weight: bold; /* Optional: makes the caret bold */
  animation: blink-caret 0.8s step-end infinite; /* Controls the blinking speed */
}

@keyframes blink-caret {
  50% { opacity: 0; }
}

.card-title-underline {
    display: inline-block;
    position: relative;
    padding: 5px;
    width: 100%;
    max-width: 1200px;
}

.card-title-underline::after {
    content: '';
    display: block;
    width: 20%;
    height: 3px;
    background-color: #17a2b8; /* Bootstrap "info" color */
    position: absolute;
    left: 0;
    bottom: -2px;
}

.card-title-underline::before {
    content: '';
    display: block;
    width: 60%;
    height: 1px;
    background-color: #ccc; /* Light gray for the rest of the underline */
    position: absolute;
    left: 0;
    bottom: -2px;
}

.ricerca-filtro-wrapper >>> .row {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 15px;
}

@media (max-width: 767.98px) {
    .card-spacing {
        margin-bottom: 15px;
    }
}
</style>